import { render, staticRenderFns } from "./FarmLocation.vue?vue&type=template&id=362087a4&"
import script from "./FarmLocation.vue?vue&type=script&lang=js&"
export * from "./FarmLocation.vue?vue&type=script&lang=js&"
import style0 from "./FarmLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VContainer,VProgressCircular})
